module.exports = __webpack_public_path__ + "assets/img/df7eb7d52f31a5ae0b32955b18e01352.png";